import {CircularProgress, styled} from '@mui/material';

const Spinner = styled(CircularProgress)({
  margin: 'auto',
});

export default Spinner;
